import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { Authorization } from "../../../Context/Authorization";

const EditRole = ({ role, onClose, onEditRole }) => {
  const [roleName, setRoleName] = useState(role.roleName);
  const [selectedPermissions, setSelectedPermissions] = useState(
    role.permissions.map((p) => p._id)
  );
  const [permissions, setPermissions] = useState([]);
  const [errors, setErrors] = useState({});
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const Confiq = Authorization();
        const response = await fetch(`${Api}/api/users/permissions`, Confiq);
        if (response.ok) {
          const data = await response.json();
          setPermissions(data);
        } else {
          console.error("Error fetching permissions:", response.statusText);
          toast.error("Error fetching permissions");
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
        toast.error("Error fetching permissions");
      }
    };

    fetchPermissions();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!roleName) {
      newErrors.roleName = "Role name is required";
    }
    if (selectedPermissions.length === 0) {
      newErrors.selectedPermissions = "At least one permission is required";
    }
    return newErrors;
  };

  const handlePermissionChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedPermissions([...selectedPermissions, value]);
    } else {
      setSelectedPermissions(selectedPermissions.filter((id) => id !== value));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fix the errors in the form");
      return;
    }

    const formData = { roleName, permissions: selectedPermissions };

    try {
      const Confiq = Authorization();
      const response = await fetch(`${Api}/api/users/roles/${role._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", ...Confiq.headers },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        toast.success("Submitted Successfully");
        onEditRole(result); // Update roles list after successful form submission
        onClose(); // Close the popup
      } else {
        console.error("Error submitting form:", response.statusText);
        toast.error("Error submitting form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form");
    }
  };

  return (
    <div className="roleForm">
      <Modal show onHide={onClose}>
        <Modal.Header>
          <Modal.Title>Edit Role</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formRoleName">
              <Form.Label>Role Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Role name"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                isInvalid={!!errors.roleName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.roleName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formPermissions">
              <Form.Label>Permissions</Form.Label>
              {permissions.map((permission) => (
                <Form.Check
                  key={permission._id}
                  type="checkbox"
                  label={permission.permissionName}
                  value={permission._id}
                  checked={selectedPermissions.includes(permission._id)}
                  onChange={handlePermissionChange}
                  isInvalid={!!errors.selectedPermissions}
                />
              ))}
              {errors.selectedPermissions && (
                <div className="invalid-feedback d-block">
                  {errors.selectedPermissions}
                </div>
              )}
            </Form.Group>

            <Button type="submit">Submit</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EditRole;
